module.exports = __webpack_public_path__ + "/images/logo-app-google.fr-FR.e6425bc.svg";